import React from "react";
import { getIconForUID } from "components/FormerEditor/utils";
import InheritenceDisplay from "components/InheritenceDisplay";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import { getCouponFormattedValue } from "utils/coupon";
import { formatUTCTime } from "utils/date";
import isNull from "lodash/isNull";

const DiscountIcon = getIconForUID("discount");
/**
 * Note only supports coupons currently
 * @param {Object} params
 * @param {Object} params.discounts
 * @returns
 */
const DiscountsSummary = ({ discounts, error }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <InheritenceDisplay
      title="Coupons"
      error={error}
      onRemove={() => setFieldValue(STATE_KEYS.SHORT_LINK.DISCOUNTS, [])}
    >
      <ul className="list ma0 pa0"></ul>
      {Array.isArray(discounts) && discounts.length ? (
        discounts.map((coupon) => {
          return (
            <li className="w-100" key={coupon.id}>
              <div className="f6 pt2 word-break flex flex-row items-center">
                <div className="pa2 bg-black-05 br2 flex flex-row mr2">
                  <DiscountIcon size={14} />
                  <div className="pl1 f6 fw5 black-80">{coupon.name}</div>
                </div>
                <span className="pl2 bl hairline-1">
                  {getCouponFormattedValue({ coupon })}
                </span>
              </div>
              {!isNull(coupon.redeem_by) && (
                <div className="fw5 f7 pl2 bl hairline-1">
                  {`Expires: ${formatUTCTime(coupon.redeem_by)}`}
                </div>
              )}
            </li>
          );
        })
      ) : (
        <li className="w-100">
          <div className="f6 pt2 word-break flex flex-row items-center">
            No coupon
          </div>
        </li>
      )}
    </InheritenceDisplay>
  );
};

export default DiscountsSummary;
